import React from 'react';
import {
  SArrowContainer,
  SContainer,
  SInfoContainer,
  SText,
  STextContainer,
  STitle,
} from './InfoBanner.styles';
import { ReactComponent as InfoIcon } from '../../assets/icons/info-with-white-bg.svg';
import { ReactComponent as ExclamationIcon } from '../../assets/icons/exclamation-mark-circle--white.svg';
import { ReactComponent as ChevronRightIcon } from '../../assets/icons/chevron-right.svg';
import { translate } from '../../utils/translate';

type InfoBannerProps = {
  titleTx?: string;
  descriptionTx: string;
  onPress?: () => void;
  variant?: 'default' | 'notice';
};

function InfoBanner({ titleTx, descriptionTx, onPress, variant = 'default' }: InfoBannerProps) {
  const isNotice = variant === 'notice';
  const displayIcon = isNotice ? <ExclamationIcon /> : <InfoIcon />;
  const variantValue = isNotice ? ('notice' as const) : undefined;

  return (
    <SContainer
      $variant={variantValue}
      {...(onPress && { onClick: onPress })}
      className={onPress ? 'cursor-pointer' : ''}
    >
      <SInfoContainer $variant={variantValue}>{displayIcon}</SInfoContainer>
      <STextContainer>
        {titleTx && <STitle $variant={variantValue}>{translate(titleTx)}</STitle>}
        <SText $variant={variantValue}>{translate(descriptionTx)}</SText>
      </STextContainer>
      {onPress && (
        <SArrowContainer $variant={variantValue}>
          <ChevronRightIcon />
        </SArrowContainer>
      )}
    </SContainer>
  );
}

export default InfoBanner;
